export default __webpack_public_path__ + "static/SunPharma-bd5db1f14031e489bc01e46283392601.svg";